var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"ResizeModal"}},[_c('div',{staticClass:"alert-hideModals alert-warning",on:{"click":function($event){$event.preventDefault();return _vm.showModals()}}},[_c('h6',[_vm._v("Clique para voltar exibir as telas.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }